import { useSelector } from "react-redux";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Controller, useWatch } from "react-hook-form";
import { TextField } from "@mui/material";
import { Search, CloudDownload, Delete } from "@mui/icons-material";

import moment from "moment";

import { selectUserData } from '../../redux/Login/LoginSlice';
import { selectAllEmpleadosList } from "../../redux/Empleados/EmpleadosSlice";

export const FiltroReporteEmpleadosAsistencia = ({
  searchReporteAsistencia,
  ReporteAsistenciaExcel, 
  reset,
  form
}) => {

  // ? HOOK-SELECTOR
  const usuario = useSelector(selectUserData);
  const listEmpleados = useSelector(selectAllEmpleadosList);

  // ? HOOK-FORM
  const { 
    control,
    handleSubmit,
    formState: { errors }
  } = form;

  // ? HOOK-WATCH
  const filtroFechas = useWatch({
    control, 
    name: 'filtroFechas'
  });

  // * FUNCION QUE ENVIA LOS DATOS.
  const onSubmit = () => {
    const filtro = {
      empleadoId: usuario.Id,
      desde: filtroFechas.desde,
      hasta: filtroFechas.hasta,
      areaId: 0,
      estado: 0,
      todos: false, 
    };

    searchReporteAsistencia(filtro);
  };

  const onExport = () => {

    const filtroApi = {
      empleadoId: usuario.Id,
      desde: moment(filtroFechas.desde).format("YYYY-MM-DD"),
      hasta: moment(filtroFechas.hasta).format("YYYY-MM-DD"),
      areaId: 0,
      estado: 0,
      todos: false, 
    };

    // * USUARIO-ID
    const usuarioId = parseInt(usuario.Id) ?? 0;

    const dataFiltro = {
      empleado: usuarioId !== 0 ? listEmpleados.find(x => x.id === usuarioId) : {},
      area: {}
    };

    ReporteAsistenciaExcel({filtro: filtroApi, dataFiltro});
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="card mb-4">
        <div className="card-body">
          <div className="row">
            <div className="col-6">
              <div className="form-group">
                <label className="fw-bold">Fecha Desde</label>
                <Controller
                  control={control}
                  className="mb-3"
                  name="filtroFechas.desde"
                  render={({ field: { value, onChange } }) => (
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        inputFormat='dd/MM/yyyy'
                        label={" "}
                        mask="__/__/____"
                        value={value}
                        onChange={onChange}
                        renderInput={(params) => (
                          <TextField
                            height={10}
                            className="form-control"
                            style={{ height: 10 }}
                            {...params}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  )}
                />
                <p className="text-danger mt-3">
                  {errors.filtroFecha?.desde?.message}
                </p>
                <p className="text-danger">{errors.filtroFecha?.desde?.message}</p>
              </div>
            </div>
            <div className="col-6">
              <div className="form-group">
                <label className="fw-bold">Fecha Hasta</label>
                <Controller
                  control={control}
                  className="mb-3"
                  name="filtroFechas.hasta"
                  render={({ field: { value, onChange } }) => (
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        inputFormat='dd/MM/yyyy'
                        minDate={filtroFechas.desde}
                        label={" "}
                        mask="__/__/____"
                        value={value}
                        onChange={onChange}
                        renderInput={(params) => (
                          <TextField
                            height={10}
                            className="form-control"
                            style={{ height: 10 }}
                            {...params}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  )}
                />
                <p className="text-danger mt-3">
                  {errors.filtroFecha?.hasta?.message}
                </p>
                <p className="text-danger">{errors.filtroFecha?.hasta?.message}</p>
              </div>
            </div>
            
            <div className="text-end mt-3">
              <button
                type="submit"
                className="btn btn-primary-mem rounded me-2"
                title="Buscar"
              >
                <Search></Search>
              </button>
              <button
                type="button"
                onClick={() => onExport()}
                className='btn btn-success rounded-6 me-2'
                title="Descargar"
              >
                <CloudDownload />
              </button>

                <a type="dow">

                </a>

              <button onClick={() => reset()} type="button" className="btn btn-danger">
                <Delete />
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};
